import axios from "axios";
import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams";
import moment from "moment";

export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_RESET_FILTERS = "saga/SET_RESET_FILTERS";
export const SET_SELECTED = "saga/SET_SELECTED";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_DATES = "saga/SET_DATES";

export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";

export const UPDATE_SEARCH_INPUT_VALUE = "saga/UPDATE_SEARCH_INPUT_VALUE";
export const UPDATE_DATES = "saga/UPDATE_DATES";

export const RESET_FILTERS = "saga/RESET_FILTERS";

const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateTableData: createAction(FETCH_TABLE_DATA),
  updateSearchInput: createAction(UPDATE_SEARCH_INPUT_VALUE),
  updateDates: createAction(UPDATE_DATES),
  setSelected: createAction(SET_SELECTED),
  resetFilters: createAction(RESET_FILTERS)
};

export const {
  updateSearchInput,
  fetchCurrentUser,
  updateTableData,
  resetFilters,
  setSelected,
  updateDates
} = actionCreators;

export default function* watchEventLogs() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_TABLE_DATA, fetchTableData);
  yield takeLatest(RESET_FILTERS, resetFiltersData);
}

export function* getCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: data.payload
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  const endDate = yield select((state) => state.eventLogs.currentUser.params.calendarEndDate);
  yield put({
    type: SET_DATES,
    payload: {
      startDate: moment(endDate).subtract(0, "days").startOf("day").format("YYYY-MM-DD"),
      endDate: endDate
    }
  });

  try {
    yield fetchTableData();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getRequestData() {
  const {
    selectedRequestDates: { startDate, endDate },
    selected: { tableType, action, search }
  } = yield select((state) => state.eventLogs);
  return {
    type: tableType?.id,
    start_date: startDate,
    end_date: endDate,
    action_type: action?.id,
    search_request: search
  };
}

function* fetchTableData() {
  const { type, start_date, end_date, action_type, search_request } = yield getRequestData();

  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });

  try {
    const url = {
      href: `${queryParams.apiVersion}admin/event_logs`,
      params: {
        type,
        start_date,
        end_date
      }
    };

    if (action_type) {
      url.params.action_type = action_type;
    }
    if (search_request) {
      url.params.search_request = search_request;
    }

    const response = yield call(axios.get, url.href, {
      params: url.params
    });

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: response.data });
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* resetFiltersData({ payload }) {
  yield put({ type: SET_RESET_FILTERS });
  yield getCurrentUserData({ payload: payload });
}
